import { ReactNode } from "react"
import { useIntl } from "react-intl"

export const COMPANY_EMAIL = "support@wizarbit.com"
export const COMPANY_PHONE_UK = "+44 2080 971 790"
export const COMPANY_PHONE_LT = "+370 700 310 96"
export const COMPANY_ADDRESS = "Perkūnkiemio g. 13-91, LT-12114, Vilnius, Lithuania"
export const LOCATED_AT = "Konstitucijos av. 21A, LT-08130 Vilnius, Lithuania "

export const UPLOAD_STYLES = {
  activeStyle: { background: "#2196f3" },
  acceptStyle: { background: "#78ff73" },
  rejectStyle: { background: "#ff1744" },
}

export const COMPANY_EMAIL_ANCHOR = <a href={`mailto:${COMPANY_EMAIL}`}>{COMPANY_EMAIL}</a>

export const CompanyPhoneNumber = ({ country }: { country?: "UK" | "LT" }) => {
  const intl = useIntl()
  const phone =
    country === "LT"
      ? COMPANY_PHONE_LT
      : country === "UK"
      ? COMPANY_PHONE_UK
      : intl.formatMessage({ id: "phone_number" })
  return <a href={`tel:${phone.replace(/ /g, "")}`}>{phone}</a>
}
